import { ProgramType } from "@/types/programs";
import { useFormStore } from "@/contexts/paymentFlowContext";
import { suggestedAmountsQueryOptions } from "@/api/suggested-amounts";
import { useQuery } from "@tanstack/react-query";
import StepsContainer from "@/components/PaymentFlow/StepsContainer";
import { useEffect } from "react";
import { livestockQueryOptions } from "@/api/livestock";
import { itemQueryOptions } from "@/api/items";
import i18n from "@/i18n";

type DonationStepperProps = {
  readonly program: ProgramType;
};

export function DonationStepper({ program }: DonationStepperProps) {
  const { currentStep, setIsSpecial, setIsItemization, setDonationType, setSpecialType } =
    useFormStore();
  const { data: suggestedAmounts } = useQuery(
    suggestedAmountsQueryOptions({
      program_id: program.id,
    }),
  );
  const { data: livestock } = useQuery(
    livestockQueryOptions({ program_id: program.id, lang: i18n.language }),
  );

  const { data: items } = useQuery(
    itemQueryOptions({ program_id: program.id, lang: i18n.language }),
  );

  useEffect(() => {
    setIsSpecial(program.is_special);
    setIsItemization(program.is_itemization);
    if (program.is_special && program.donation_types.length > 0) {
      setDonationType(program.donation_types[0].id);
      program.special_type && setSpecialType(program.special_type);
    }
  }, [program]);

  return (
    <div className="flex h-full w-full flex-col">
      <StepsContainer
        step={currentStep}
        program={program}
        suggestedAmounts={suggestedAmounts}
        livestock={livestock}
        items={items}
      />
    </div>
  );
}
